import React, { useState } from 'react'
import '../../assets/styles/new-data.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import commonService from '../../services/otherServices';
import Advertisment from '../../components/Common/Advertisment';
import Popup from '../../components/Common/Error'

const Dashboard = () => {
    const [showSubmitPopup, setShowSubmitPopup] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);


    interface FormData {
        industry: string;
        job_titles: string;
        geography: string;
        employee_size: string;
        technology: string;
        revenue_size: string;
        sic_code: string;
        additional_requirement: string;
    }

    const [formData, setFormData] = useState<FormData>({
        industry: '',
        job_titles: '',
        geography: '',
        employee_size: '',
        technology: '',
        revenue_size: '',
        sic_code: '',
        additional_requirement: ''
    });


    const requiredFields: (keyof typeof formData)[] = [
        "industry",
        "job_titles",
        "geography",
    ];

    const isFormComplete = requiredFields.every(
        field => formData[field].trim() !== ""
    );

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };



    const submitCustomDataRequest = async () => {
        if(!isFormComplete)
            return;
        // Here you can handle the form submission, e.g., send data to the server
        try {
            setIsLoading(true);
            const response = await commonService.newRequest(formData);
            if (response && response?.data?.status === 'failed') {
                setErrorMsg('Failed to submit request');
                return;
            }
            setShowSubmitPopup(true);
            setFormData({
                industry: '',
                job_titles: '',
                geography: '',
                employee_size: '',
                technology: '',
                revenue_size: '',
                sic_code: '',
                additional_requirement: ''
            });
        } catch (err) {
            let errorMessage = 'Something went wrong';

            if (err instanceof Error) {
                errorMessage = err.message;
            } else if (typeof err === 'string') {
                errorMessage = err;
            }
            setErrorMsg(errorMessage);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className="container">               
                <Advertisment />
                <div className="data-form-white-box">
                    <div>
                        <p className="your-data">Submit Your Custom Data Requirement</p>
                        <p className="track" style={{fontWeight:"500"}}>Tell us what type of data you’re looking for, and our team will deliver a tailored list that meets your exact targeting needs.</p>
                    </div>

                    <div className="">
                        <div className="dashboard-form">

                            <div className="row g-3">
                                {/* COLUMN 1 */}
                                <div className="col-md-4">
                                    <div className="dashboard-input-group">
                                        <label className="dashboard-input-label">Industry*</label>
                                        <input
                                            type="text"
                                            className="dashboard-input"
                                            placeholder="Enter target industry"
                                            onChange={handleChange}
                                            name="industry"
                                            value={formData.industry}
                                            tabIndex={1}
                                        />
                                    </div>

                                    <div className="dashboard-input-group mt-3">
                                        <label className="dashboard-input-label">Employee Size</label>
                                        <input
                                            type="text"
                                            className="dashboard-input"
                                            placeholder="Enter company employee range"
                                            onChange={handleChange}
                                            name="employee_size"
                                            value={formData.employee_size}
                                            tabIndex={4}
                                        />
                                    </div>

                                    <div className="dashboard-input-group mt-3">
                                        <label className="dashboard-input-label">Technology</label>
                                        <input
                                            type="text"
                                            className="dashboard-input"
                                            placeholder="Specify technologies or tools of interest"
                                            onChange={handleChange}
                                            name="technology"
                                            value={formData.technology}
                                            tabIndex={7}
                                        />
                                    </div>
                                </div>

                                {/* COLUMN 2 */}
                                <div className="col-md-4">
                                    <div className="dashboard-input-group">
                                        <label className="dashboard-input-label">Job Titles*</label>
                                        <input
                                            type="text"
                                            className="dashboard-input"
                                            placeholder="Enter job roles or decision-makers"
                                            onChange={handleChange}
                                            name="job_titles"
                                            value={formData.job_titles}
                                            tabIndex={2}
                                        />
                                    </div>

                                    <div className="dashboard-input-group mt-3">
                                        <label className="dashboard-input-label">Revenue Size</label>
                                        <input
                                            type="text"
                                            className="dashboard-input"
                                            placeholder="Enter annual company revenue range"
                                            onChange={handleChange}
                                            name="revenue_size"
                                            value={formData.revenue_size}
                                            tabIndex={5}
                                        />
                                    </div>

                                    <div className="dashboard-input-group mt-3">
                                        <label className="dashboard-input-label">SIC Code</label>
                                        <input
                                            type="text"
                                            className="dashboard-input"
                                            placeholder="Enter specific SIC or NAICS codes"
                                            onChange={handleChange}
                                            value={formData.sic_code}
                                            name="sic_code"
                                            tabIndex={8}
                                        />
                                    </div>
                                </div>

                                {/* COLUMN 3 */}
                                <div className="col-md-4 d-flex">
                                    <div className="dashboard-input-group w-100">
                                        <label className="dashboard-input-label">Geography*</label>
                                        <input
                                            type="text"
                                            className="dashboard-input"
                                            placeholder="Enter preferred regions or countries"
                                            onChange={handleChange}
                                            name="geography"
                                            value={formData.geography}
                                            tabIndex={3}
                                        />

                                        <label className="dashboard-input-label" style={{marginTop:"9px"}}>
                                            Additional Requirement
                                        </label>
                                        <textarea
                                            className="dashboard-input dashboard-textarea"
                                            placeholder="Describe any other filters or custom needs"
                                            onChange={handleChange}
                                            name="additional_requirement"
                                            value={formData.additional_requirement}
                                            tabIndex={6}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* SUBMIT */}
                            <div className="d-flex justify-content-center mt-4">
                                <button
                                    type="button"
                                    className={`submit-request-btn ${isFormComplete ? 'active' : ''}`}
                                    // disabled={!isFormComplete}
                                    style={{ cursor:!isFormComplete ?"not-allowed":"pointer"}}
                                    onClick={() => submitCustomDataRequest()}
                                    tabIndex={9}
                                >
                                    {isLoading ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            Submitting...
                                        </>
                                    ) : (
                                        "Submit Request"
                                    )}


                                </button>
                            </div>

                            <p className="experts" style={{fontStyle:"italic"}}>Our data experts will review your request and deliver the most relevant, compliant B2B data within 24–48 hours.</p>


                            {showSubmitPopup && (
                                <div className="submit-popup-overlay">
                                    <div className="submit-popup">
                                        {/* Close icon */}
                                        <div className="d-flex justify-content-end">
                                            <img src="/images/close-active.png" alt="" className="submit-popup-close"
                                                onClick={() => setShowSubmitPopup(false)}
                                            />
                                        </div>

                                        <div className="d-flex justify-content-center">
                                            <img src="/images/hand-shak.png" alt="" />
                                        </div>

                                        {/* Content */}
                                        <p className="submit-popup-title">Thank you!</p>
                                        <p className="submit-popup-text">
                                            Our team will review your requirement and get back with a tailored dataset shortly.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* error popup */}
            <Popup
                isOpen={!!errorMsg}
                onClose={() => setErrorMsg("")}
                title={errorMsg}
                iconSrc="/images/grey-cancel-cta.png"
            />
        </>
    )
}

export default Dashboard;